﻿import { BufferCalculationType } from 'business/BufferCalculationType';
import { IIngredient, IIngredientStockDTO, Ingredient, IngredientStockDTO } from 'business/models/Models';
import { isNullOrUndefined } from 'utils/Global';
export class BufferCalculator {
  MinpH: number;
  MaxpH: number;
  NeutralpH: number;
  MinFraction: number;
  MaxFraction: number;
  ingredientId: number;
  calculationType: number;
  pKaValue: number;
  stockMinpH: number;
  stockMaxpH: number;
  xValues: number[];
  yValues: number[];
  stockMinRatio: number;
  stockMaxRatio: number;
  minGraphX: number;
  maxGraphX: number;

  constructor(
    ingredient: IIngredient,
    lowpHStock: IIngredientStockDTO,
    highpHStock: IIngredientStockDTO
  ) {
    this.MinpH = 0;
    this.MaxpH = 14;
    this.NeutralpH = 7;

    this.MinFraction = 0.0;
    this.MaxFraction = 1.0;

    this.ingredientId = null;
    this.calculationType = null;
    this.pKaValue = null;

    this.stockMinpH = this.MaxpH;
    this.stockMaxpH = this.MinpH;
    this.xValues = [];
    this.yValues = [];
    this.stockMinRatio = 0;
    this.stockMaxRatio = 0;
    this.minGraphX = this.MinpH;
    this.maxGraphX = this.MaxpH;

    //if (!ValidateBuffers(lowpHStock, highpHStock))
    //    throw new ValidationException("Unknown error occured in validation.  Cannot be instantiated");

    let stockLowpH;
    let stockHighpH;
    let pKa = this.MinpH;

    stockLowpH = stockHighpH = lowpHStock.stockPh;

    if (highpHStock != null) stockHighpH = highpHStock.stockPh;

    //if (!ingredient.IspKaNull())
    pKa = ingredient.pKa;

    let bufferDataPoints = [];
    if (!isNullOrUndefined(ingredient?.bufferDataPoint)) {
      bufferDataPoints = ingredient.bufferDataPoint; 
      this.Initialize(
        ingredient.id,
        ingredient.bufferCalculationTypeId,
        stockLowpH,
        stockHighpH,
        pKa,
        bufferDataPoints
      );
    }
  }
  Initialize(
    ingredId,
    calcType,
    stockLowpH,
    stockHighpH,
    pkaVal,
    bufferDataPoints
  ) {
    this.calculationType = calcType;
    this.ingredientId = ingredId;

    if (
      this.calculationType != BufferCalculationType.pKa.ID &&
      this.calculationType != BufferCalculationType.Interpolate.ID
    )
      throw (
        new Error('Invalid BufferCalculationType value for ingredient ID = ' +
          this.ingredientId
        ));

    if (stockLowpH > stockHighpH)
      throw new Error('Stock Low pH is higher than Stock High pH');

    if (stockLowpH < this.stockMinpH) this.stockMinpH = stockLowpH;

    if (stockHighpH > this.stockMaxpH) this.stockMaxpH = stockHighpH;

    this.minGraphX = this.stockMinpH;
    this.maxGraphX = this.stockMaxpH;

    if (this.calculationType == BufferCalculationType.pKa.ID) {
      this.pKaValue = pkaVal;
      return;
    }

    // set up calculations for linear interpolation

    this.xValues = [bufferDataPoints.length];
    this.yValues = [bufferDataPoints.length];

    let i = 0;
    for (let bdp of bufferDataPoints) {
      this.xValues[i] = bdp.ph;
      this.yValues[i] = bdp.ratio;
      i++;
    }
    this.xValues = this.xValues.sort((v1, v2) => v1 - v2);
    this.yValues = this.yValues.sort((v1, v2) => v2 - v1);

    i = this.IndexPhValue(this.stockMinpH);
    if (i != -1) this.stockMinRatio = this.yValues[i];
    // real/given value does not exist, find the interpolated one
    else
      this.stockMinRatio = this.GetInterpolatedAcidToBaseRatio(this.stockMinpH);

    i = this.IndexPhValue(this.stockMaxpH);
    if (i != -1) this.stockMaxRatio = this.yValues[i];
    // real/given value does not exist, find the interpolated one
    else
      this.stockMaxRatio = this.GetInterpolatedAcidToBaseRatio(this.stockMaxpH);
  }

  //constructor(ingredientID, dataSet)
  //{

  //  SystemDataSet.IngredientRow ingred = dataSet.Ingredient.FindByID( ingredientID );
  //  SystemDataSet.IngredientStockRow[] stocks =
  //    (SystemDataSet.IngredientStockRow[]) dataSet.IngredientStock.Select( "IngredientID = " + ingredientID + " AND IsBuffer = 1 ", "StockPH" );
  //  SystemDataSet.BufferDataPointRow[] bufferDataPoints =
  //    (SystemDataSet.BufferDataPointRow[]) dataSet.BufferDataPoint.Select( "IngredientID = " + ingredientID, "pH" );

  //  double pKaVal = double.NaN;
  //  double stockLowpH = MaxpH,
  //         stockHighpH = MinpH;

  //  foreach( SystemDataSet.IngredientStockRow stock in stocks )
  //  {
  //    if( stock.IsStockPHNull() )
  //      continue;

  //    if( stock.StockPH < stockLowpH )
  //      stockLowpH = stock.StockPH;

  //    if( stock.StockPH > stockHighpH )
  //      stockHighpH = stock.StockPH;
  //  }

  //  if( !ingred.IspKaNull() )
  //    pKaVal = ingred.pKa;

  //  Initialize( ingred.ID, ingred.BufferCalculationTypeID, stockLowpH, stockHighpH, pKaVal, bufferDataPoints );
  //}

  get XValues() {
    return this.xValues;
  }

  get YValues() {
    return this.yValues;
  }

  get GraphMinX() {
    return this.minGraphX;
  }

  get GraphMaxX() {
    return this.maxGraphX;
  }

  get StockMinPH() {
    if (this.stockMinpH <= this.stockMaxpH) return this.stockMinpH;
    return null;
  }

  get StockMaxPH() {
    if (this.stockMinpH <= this.stockMaxpH) return this.stockMaxpH;
    return null;
  }

  LowFraction(pH): number {
    if (
      this.calculationType != BufferCalculationType.pKa.ID &&
      this.calculationType != BufferCalculationType.Interpolate.ID
    )
      throw (
        'Invalid BufferCalculationType value for ingredient ID = ' +
        this.ingredientId
      );

    if (this.calculationType == BufferCalculationType.pKa.ID)
      return this.PKaCalculation(pH);

    return this.InterpolatedCalculation(pH);
  }

  HighFraction(pH): number {
    return 1 - this.LowFraction(pH);
  }

  InterpolatedCalculation(pH): number {
    let lowFraction = 1.0;

    if (this.xValues.length == 0 || this.stockMinRatio == this.stockMaxRatio)
      return lowFraction;

    let ratio;
    ratio = this.GetInterpolatedAcidToBaseRatio(pH);

    /*
     * But its not that simple.  To find the low fraction, we know that value must fall between 0 & 1.
     * What ratio is giving us is the acid/base ratio, not the mixing percentage.
     *
     * Low Fraction = (ratio-MaxRatio)/(MinRatio-MaxRatio) ---- (4)
     *
     * These ratios are not y1 or y2 ( of eq. (2) ) ... they are the absolute of the selected stocks.
     * i.e. ratios of stockMinPH & stockMaxPH( or minGraphX & MaxGraphX)
     */

    lowFraction =
      (ratio - this.stockMaxRatio) / (this.stockMinRatio - this.stockMaxRatio);
    return lowFraction;
  }

  GetInterpolatedAcidToBaseRatio(pH): number {
    let highPHIndex;
    let lowPHIndex;

    lowPHIndex = this.IndexFloorPhValue(pH);
    highPHIndex = this.IndexCeilPhValue(pH);

    if (lowPHIndex == highPHIndex) return this.yValues[lowPHIndex];

    let x1, x2;
    let y1, y2;
    let m, b;

    /*
     * Find the interpolated ratio value
     * Lets put some trigonometry here, although it has nothing to do with chemistry, but science is science :)
     * slope-intercept formula
     * y = mx + b; --- (1)
     * where m = slope && b = y-intercept
     *
     * and m = (y1 - y2)/(x1 - x2) --- (2)
     *
     * First we'll find the floor pH Index, that will serve as the first point of the line (x1, y1),
     * and then ciel will give us the second point of the line (x2, y2).  Pputting these in (2), we get m.
     *
     * Now only b is unknown variable, which will determine the y-intercept of the equation.
     * To find that why not use the first point as the line passes through that point
     * y1 = m(x1) + b
     * OR
     * b = y1 - m(x1) --- (3)
     * After known 'b', we can get any value we want ... so let's give it a try
     * Remember all 'x' values are pH, and all 'y' values are ratios here and we have to find 'y'.
     */

    x1 = this.xValues[lowPHIndex];
    y1 = this.yValues[lowPHIndex];
    x2 = this.xValues[highPHIndex];
    y2 = this.yValues[highPHIndex];

    m = (y1 - y2) / (x1 - x2);
    b = y1 - m * x1;

    return m * pH + b;
  }

  IndexPhValue(pH) {
    for (let i = 0; i < this.xValues.length; i++)
      if (this.xValues[i] == pH) return i;
    return -1;
  }

  IndexFloorPhValue(pH) {
    // find index of fist xValues value less than or equal to x
    let low;
    for (low = this.xValues.length - 1; low >= 0; low--)
      if (this.xValues[low] <= pH) return low;
    return low + 1;
    //throw new ApplicationException( string.Format( "pH value {0} below range of data set", pH.ToString( "R" ) ) );
  }

  IndexCeilPhValue(pH) {
    // find index of xValues value greater than or equal to x
    let high;
    for (high = 0; high < this.xValues.length; high++)
      if (this.xValues[high] >= pH) return high;
    return high - 1;
    // throw new ApplicationException( string.Format( "pH value {0} above range of data set", pH.ToString( "R" ) ) );
  }

  PKaCalculation(pH) {
    let R1,
      R2,
      R3,
      A1,
      A2,
      B1,
      B2,
      F1 = 1;

    if (this.stockMinpH == this.stockMaxpH) return F1;

    R1 = 10 ** (this.stockMinpH - this.pKaValue); // Math.Pow(10, this.stockMinpH - this.pKaValue );
    R2 = 10 ** (this.stockMaxpH - this.pKaValue); //Math.Pow(10, this.stockMaxpH - this.pKaValue );
    R3 = 10 ** (pH - this.pKaValue); //Math.Pow(10, pH - this.pKaValue );

    A1 = 1 / (1 + R1);
    A2 = 1 / (1 + R2);
    B1 = 1 / (1 + 1 / R1);
    B2 = 1 / (1 + 1 / R2);
    //F1 = Math.round((R3 * A2 - B2) / (B1 - B2 - R3 * (A1 - A2)), 3);
    F1 = parseFloat(((R3 * A2 - B2) / (B1 - B2 - R3 * (A1 - A2))).toFixed(3));

    return F1;
  }

  ValidateBuffers(
    lowpHStock: IngredientStockDTO,
    highpHStock: IngredientStockDTO
  ): boolean {
    if (highpHStock == null) highpHStock = lowpHStock;

    if (!lowpHStock.isBuffer)
      throw 'Stock selected, as low PH stock, cannot be used as a buffer stock.';

    if (!highpHStock.isBuffer)
      throw 'Stock selected, as high PH stock, cannot be used as a buffer stock.';

    if (highpHStock.ingredientId != lowpHStock.ingredientId)
      throw 'Selected stocks are not of the same ingredient.';

    if (lowpHStock.stockPh > highpHStock.stockPh)
      throw 'Low pH stock has higher pH than high pH stock.';

    return true;
  }

  ValidateBuffersPH(
    defaultpHStock: IngredientStockDTO,
    optionalHighpHStock: IngredientStockDTO,
    pH: number
  ) {
    if (optionalHighpHStock == null) {
      // means it is a single vial Buffer
      if (!defaultpHStock.isBuffer)
        throw 'Stock selected, as low PH stock, cannot be used as a buffer stock.';

      if (pH != defaultpHStock.stockPh)
        throw "For a single vial buffer, pH must be equal to the stock's pH";

      return true;
    }
    // it is a multi-vial buffer

    if (!this.ValidateBuffers(defaultpHStock, optionalHighpHStock))
      return false;

    let lowpH = defaultpHStock.stockPh;
    let highpH = optionalHighpHStock.stockPh;

    if (pH < lowpH || pH > highpH)
      throw "For a muti-vial buffer, pH must be between low pH stock's pH and high pH stock's pH for this ingredient";

    return true;
  }
}
